import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {GraduateComponent} from "./graduate/graduate.component";
import {PostGraduateComponent} from "./post-graduate/post-graduate.component";
import {DoctoralComponent} from "./doctoral/doctoral.component";
import {DiplomaComponent} from "./diploma/diploma.component";
import {IntegratedComponent} from "./integrated/integrated.component";
import {CertificateComponent} from "./certificate/certificate.component";

const routes: Routes = [
    { path: 'graduate', component: GraduateComponent },
    { path: 'post-graduate', component: PostGraduateComponent },
    { path: 'doctoral', component: DoctoralComponent },
    { path: 'diploma', component: DiplomaComponent },
    { path: 'integrated', component: IntegratedComponent },
    { path: 'certificate', component: CertificateComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HeaderProgramsRoutingModule { }
